const API_URL =
  "https://www.flickr.com/services/rest/?format=json&api_key=3c124bfd9b0776eceffa8c9596b99c00&method=";

export { API_URL };
